import { ComponentsModule } from '$components/components.module';
import { AgendamentoFormPage } from '$pages/agendamento/agendamento-form/agendamento-form';
import { AgendamentoListPage } from '$pages/agendamento/agendamento-list/agendamento-list';
import { AtendimentoListPage } from '$pages/atendimento/atendimento-list/atendimento-list';
import { AtendimentoViewPage } from '$pages/atendimento/atendimento-view/atendimento-view';
import { LoginPage } from '$pages/auth/login/login';
import { RecoveryPasswordChangePage } from '$pages/auth/recovery-password/recovery-password-change/recovery-password-change';
import { RecoveryPasswordCodePage } from '$pages/auth/recovery-password/recovery-password-code/recovery-password-code';
import { RecoveryPasswordRequestPage } from '$pages/auth/recovery-password/recovery-password-request/recovery-password-request';
import { RegisterPage } from "$pages/auth/register/register";
import { RegisterCodePage } from '$pages/auth/register/register-code/register-code';
import { DenunciaFormPage } from '$pages/denuncia/denuncia-form/denuncia-form';
import { DenunciaListPage } from '$pages/denuncia/denuncia-list/denuncia-list';
import { DenunciaViewPage } from '$pages/denuncia/denuncia-view/denuncia-view';
import { DuvidasListPage } from '$pages/duvidas-list/duvidas-list';
import { HomePage } from '$pages/home/home';
import { MapPage } from '$pages/map/map';
import { ObservacaoPage } from '$pages/observacao/observacao';
import { SelecionarBairroPage } from '$pages/selecionar-bairro/selecionar-bairro';
import { SettingsPage } from '$pages/settings/settings';
import { TermoAceiteViewPage } from '$pages/termo-aceite-view/termo-aceite-view';
import { PipesModule } from '$pipes/pipes.module';
import { AgendamentoProvider } from '$providers/agendamento';
import { AtendimentoProvider } from '$providers/atendimento';
import { BairroProvider } from '$providers/bairro';
import { DenunciaProvider } from '$providers/denuncia';
import { DuvidaProvider } from '$providers/duvida';
import { ImageProvider } from '$providers/image';
import { ItemProvider } from '$providers/item';
import { LoginProvider } from '$providers/login';
import { MapProvider } from '$providers/map';
import { ServerProvider } from '$providers/server';
import { SettingsProvider } from '$providers/settings';
import { TipoQueixaProvider } from '$providers/tipo-queixa';
import { ViewProvider } from '$providers/view';
import { HttpClientModule } from '@angular/common/http';
import { ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { Camera } from '@ionic-native/camera';
import { Geolocation } from '@ionic-native/geolocation';
import { ImagePicker } from '@ionic-native/image-picker';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';
import { IonicStorageModule } from '@ionic/storage';
import { SoftwaredataModule } from '@softwaredata/ionic-commons';
import { BrMaskerModule } from 'brmasker-ionic-3';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { RecaptchaLoaderService, RecaptchaModule, RecaptchaSettings, RECAPTCHA_SETTINGS } from 'ng-recaptcha';
import { RecaptchaFormsModule } from 'ng-recaptcha/forms';
import { MyApp } from './app.component';

@NgModule({
  declarations: [
    MyApp,

    // Pages
    LoginPage,
    RegisterCodePage,
    RecoveryPasswordRequestPage,
    RecoveryPasswordCodePage,
    RecoveryPasswordChangePage,
    HomePage,
    SelecionarBairroPage,
    SettingsPage,
    RegisterPage,
    TermoAceiteViewPage,
    MapPage,
    ObservacaoPage,
    DenunciaFormPage,
    DenunciaListPage,
    DenunciaViewPage,
    AtendimentoListPage,
    AtendimentoViewPage,
    DuvidasListPage,
    AgendamentoListPage,
    AgendamentoFormPage,
  ],
  imports: [
    BrowserModule,
    RecaptchaModule,
    RecaptchaFormsModule,
    HttpClientModule,
    PipesModule,
    IonicModule.forRoot(MyApp, {
      backButtonText: '',
      platforms: {
        ios: {
          backButtonText: 'Voltar',
        }
      }
    }),
    IonicStorageModule.forRoot({
      name: '__cm156',
      driverOrder: ['indexeddb', 'sqlite', 'websql']
    }),
    BrMaskerModule,
    ComponentsModule,
    SoftwaredataModule
  ],
  exports: [
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    LoginPage,
    RegisterCodePage,
    RecoveryPasswordRequestPage,
    RecoveryPasswordCodePage,
    RecoveryPasswordChangePage,
    HomePage,
    SelecionarBairroPage,
    SettingsPage,
    RegisterPage,
    TermoAceiteViewPage,
    MapPage,
    ObservacaoPage,
    DenunciaFormPage,
    DenunciaListPage,
    DenunciaViewPage,
    AtendimentoListPage,
    AtendimentoViewPage,
    DuvidasListPage,
    AgendamentoListPage,
    AgendamentoFormPage,

  ],
  providers: [
    StatusBar,
    SplashScreen,
    ImagePicker,
    Camera,
    Geolocation,
    InAppBrowser,
    { provide: ErrorHandler, useClass: IonicErrorHandler },
    ServerProvider,
    ViewProvider,
    SettingsProvider,
    LoginProvider,
    ImageProvider,
    BairroProvider,
    MapProvider,
    DenunciaProvider,
    TipoQueixaProvider,
    AgendamentoProvider,
    DuvidaProvider,
    AtendimentoProvider,
    RecaptchaLoaderService,
    {
      provide: RECAPTCHA_SETTINGS,
      useValue: { siteKey: '6LfpPWYUAAAAALDXh40nR6PQTooBIS3av_Zx3z6K' } as RecaptchaSettings,
    },
    ItemProvider,
  ]
})
export class AppModule { }


// WEBPACK FOOTER //
// ./src/app/app.module.ts